import {
  //
  ADD_HOME,
  ADD_HOME_FAILURE,
  ADD_HOME_SUCCESS,
  //
  DELETE_HOME,
  DELETE_HOME_FAILURE,
  DELETE_HOME_SUCCESS,
  //
  EDIT_HOME,
  EDIT_HOME_FAILURE,
  EDIT_HOME_SUCCESS,
  //
  FETCH_HOMES,
  FETCH_HOMES_FAILURE,
  FETCH_HOMES_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  SEARCH_HOME,
  SEARCH_HOME_SUCCESS,
  SEARCH_HOME_FAILURE,
} from "./constants";

// List
export const fetchHomes = (payload) => ({
  type: FETCH_HOMES,
  payload,
});
export const fetchHomesSuccess = (payload) => ({
  type: FETCH_HOMES_SUCCESS,
  payload,
});
export const fetchHomesFailure = (payload) => ({
  type: FETCH_HOMES_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addHome = (payload) => ({
  type: ADD_HOME,
  payload,
});
export const addHomeSuccess = (payload) => ({
  type: ADD_HOME_SUCCESS,
  payload,
});
export const addHomeFailure = (payload) => ({
  type: ADD_HOME_FAILURE,
  payload,
});
// EDIT
export const editHome = (payload) => ({
  type: EDIT_HOME,
  payload,
});
export const editHomeSuccess = (payload) => ({
  type: EDIT_HOME_SUCCESS,
  payload,
});
export const editHomeFailure = (payload) => ({
  type: EDIT_HOME_FAILURE,
  payload,
});
// DELETE
export const deleteHome = (payload) => ({
  type: DELETE_HOME,
  payload,
});
export const deleteHomeSuccess = (payload) => ({
  type: DELETE_HOME_SUCCESS,
  payload,
});
export const deleteHomeFailure = (payload) => ({
  type: DELETE_HOME_FAILURE,
  payload,
});
// SEARCH
export const searchHome = (payload) => ({
  type: SEARCH_HOME,
  payload,
});
export const searchHomeSuccess = (payload) => ({
  type: SEARCH_HOME_SUCCESS,
  payload,
});
export const searchHomeFailure = (payload) => ({
  type: SEARCH_HOME_FAILURE,
  payload,
});
